var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcShippingFee = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.818,
    height: 95.877,
    viewBox: "0 0 104.818 95.877",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ffe200;\n      }\n\n      .cls-4 {\n        fill: #666;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-6 {\n        filter: url(#Rectangle_466);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_466",
    x: 0,
    y: 0,
    width: 104.818,
    height: 95.877,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5731",
    "data-name": "Rectangle 5731",
    className: "cls-1",
    width: 40,
    height: 39.331
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_110_1",
    "data-name": "Component 110 \\u2013 1",
    transform: "translate(15 11.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957",
    transform: "translate(0 -0.763)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, -15, -10.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466-2",
    "data-name": "Rectangle 466",
    className: "cls-2",
    width: 74.818,
    height: 65.877,
    rx: 25,
    transform: "translate(15 12)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    className: "cls-3",
    cx: 6.775,
    cy: 6.775,
    r: 6.775,
    transform: "translate(63.906 0.763)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    className: "cls-4",
    cx: 7.527,
    cy: 7.527,
    rx: 7.527,
    ry: 7.527,
    transform: "translate(0 55.555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(18.453 15.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2621",
    "data-name": "Group 2621",
    className: "cls-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    className: "cls-1",
    d: "M39.327,19.494a19.648,19.648,0,0,1-37.7,7.942A19.5,19.5,0,0,1,6.018,5.519,19.263,19.263,0,0,1,21.884.112a12.764,12.764,0,0,1,1.856.3,1.56,1.56,0,0,1,1.239,1.772,1.478,1.478,0,0,1-1.646,1.3c-.812-.049-1.618-.2-2.43-.264A16.438,16.438,0,1,0,35.514,14.931a1.572,1.572,0,0,1,.892-2.072,1.551,1.551,0,0,1,2.083,1.048,16.87,16.87,0,0,1,.837,5.587",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    className: "cls-1",
    d: "M23.752,16.887c0,.607.023,1.215-.008,1.82-.023.459.147.6.6.643a5.554,5.554,0,0,1,.06,11.062c-.561.078-.695.28-.664.787.036.584.02,1.172,0,1.758a1.547,1.547,0,0,1-3.095-.025c-.014-.628-.022-1.257,0-1.884.017-.424-.136-.563-.563-.618a5.552,5.552,0,0,1-5.021-4.542A5.148,5.148,0,0,1,15,24.825a1.544,1.544,0,0,1,3.084-.116,2.544,2.544,0,0,0,1.659,2.435c.717.266.9.139.9-.625,0-1.109-.021-2.219.01-3.328.013-.5-.149-.708-.653-.771a5.575,5.575,0,0,1,0-11.094c.514-.072.679-.239.65-.737-.036-.6-.022-1.214,0-1.82a1.546,1.546,0,0,1,3.091-.009c.019.628.027,1.257,0,1.884-.02.437.112.607.574.682a5.6,5.6,0,0,1,5.015,4.645,5.139,5.139,0,0,1,.064,1.061,1.547,1.547,0,0,1-3.086.086,2.655,2.655,0,0,0-1.75-2.517c-.633-.238-.8-.127-.808.527-.006.586,0,1.173,0,1.759m-3.1,0c0-.585,0-1.169,0-1.755-.006-.634-.151-.742-.75-.573a2.529,2.529,0,0,0-1.786,2.387,2.574,2.574,0,0,0,2.018,2.346c.4.076.529-.086.523-.464-.012-.647,0-1.294,0-1.942m3.5,10.365a2.369,2.369,0,0,0-.036-4.719c-.228.02-.351.118-.351.345q0,2,0,4a.328.328,0,0,0,.39.371",
    transform: "translate(-2.515 -1.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    className: "cls-1",
    d: "M39.988,7.586H38.128c-1.381,0-2.761,0-4.142,0a1.563,1.563,0,0,1-1.778-1.513,1.6,1.6,0,0,1,1.73-1.66c1.8-.03,3.6-.011,5.4-.012h.7A7,7,0,0,0,39,3.148a1.642,1.642,0,0,1-.461-1.377A1.45,1.45,0,0,1,39.5.551,1.549,1.549,0,0,1,41.2.88c1.308,1.382,2.6,2.782,3.859,4.206a1.472,1.472,0,0,1-.062,1.963q-1.868,2.074-3.792,4.1a1.52,1.52,0,0,1-2.152.052A1.558,1.558,0,0,1,38.911,9c.356-.433.754-.83,1.134-1.243l-.057-.169",
    transform: "translate(-5.401 -0.073)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcShippingFee);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-shippingFee.ecb2d68e2edccbf08c946787fe7bf7be.svg";